import { BaseViewStore} from 'core/stores';
import { action } from "mobx";

class RelationshipChangeModalStore extends BaseViewStore {

    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
    }

    @action.bound
    async takeMeToBrightree() {
        try {
            window.open(`${this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl}Patient/frmPatientInsuranceRO.aspx?PatientKey=${this.modalParams.data.patientKey}&Edit=0`);
            // this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
    }
}

export default RelationshipChangeModalStore;
